/* global CLOUDINARY_SHARE */
import React, { PureComponent } from 'react';
import ReactTooltip from 'react-tooltip';
import authProtection from '../../HOCs/authProtection';
import withAlertTimeout from '../../HOCs/withAlertTimeout';
import { CLOUDINARY_SHARE } from '../../helpers/cloudinaryConstants';
import PowerImageModal from './Modals/PowerImageModal';
import SquareGridThumb from './SquareGridThumb';
import truncateString from './truncateString';
import axios from 'axios';
import UnpowerImageModal from './Modals/UnpowerImageModal';
import buildNetlify from '../../helpers/buildNetlify';

class SingleImageView extends PureComponent {
  static defaultProps = {
    maxTitleLength: 60,
  };

  constructor(props) {
    super(props);
    this.state = {
      image: this.props.image,
      poweredIconColor: '#000',
      powered: false,
      showPowerImageModal: false,
      showUnpowerImageModal: false,
      isPowering: false,
      isUnpowering: false,
      poweredID: null,
    };

    this.closeModal = this.closeModal.bind(this);
    this.updatePoweredID = this.updatePoweredID.bind(this);
    // this.fetchImage = this.fetchImage.bind(this)
    this.onPowerImageClick = this.onPowerImageClick.bind(this);
    this.onUnpowerImageClick = this.onUnpowerImageClick.bind(this);
    this.onSwapImageClick = this.onSwapImageClick.bind(this);
    this.powerImage = this.powerImage.bind(this);
    this.unpowerImage = this.unpowerImage.bind(this);
    this.copyPoweredID = this.copyPoweredID.bind(this);
  }

  closeModal() {
    this.setState({ showPowerImageModal: false, showUnpowerImageModal: false });
  }

  updatePoweredID(id) {
    this.setState({ poweredID: id });
  }

  powerImage(imageID) {
    const { id } = this.props;
    this.setState({ isPowering: true });
    const token = sessionStorage.getItem('token');
    const headers = { headers: { Authorization: `Bearer ${token}` } };

    axios
      .put(`/api/proxy/v2/images/${imageID}/power/${this.state.poweredID}`, null, headers)
      .then(() => {
        this.props.showSuccessNotification('Image Powered.');
        this.props.getAllAlbumsData();
      })
      .catch(err => {
        console.log(err);
        this.props.showFailureNotification();
      })
      .finally(() => {
        buildNetlify(id, token);
        this.closeModal();

        this.setState({ isPowering: false });
      });
  }

  unpowerImage(imageID) {
    const { id } = this.props;
    this.setState({ isUnpowering: true });
    const token = sessionStorage.getItem('token');
    const headers = { headers: { Authorization: `Bearer ${token}` } };

    axios
      .delete(`/api/proxy/v2/images/${imageID}/power`, headers)
      .then(() => {
        this.props.showSuccessNotification('Image Unpowered.');
        this.props.getAllAlbumsData();
      })
      .catch(err => {
        console.log(err);
        this.props.showFailureNotification();
      })
      .finally(() => {
        buildNetlify(id, token);
        this.closeModal();

        this.setState({ isUnpowering: false });
      });
  }

  // fetchImage() {
  //   const token = sessionStorage.getItem('token');
  //   const headers = { headers: { Authorization: `Bearer ${token}` } };
  //   axios
  //   .get(`/api/proxy/v2/images/${this.state.image.id}`, headers)
  //   .then(({ data }) => {
  //       this.setState({image: data})
  //   })
  //   .catch(error => {
  //     console.log(error)
  //   })

  // }

  onPowerImageClick() {
    return e => {
      e.stopPropagation();
      this.setState({
        showPowerImageModal: true,
      });
    };
  }

  onUnpowerImageClick() {
    return e => {
      e.stopPropagation();
      this.setState({
        showUnpowerImageModal: true,
      });
    };
  }

  onSwapImageClick() {
    return e => {
      e.stopPropagation();
      this.props.openModal(this.state.image.id);
    };
  }

  copyPoweredID() {
    return e => {
      e.stopPropagation();
      var copyText = document.createElement('textarea');
      copyText.innerText = this.state.image.poweredId;
      document.body.appendChild(copyText);
      copyText.select();
      document.execCommand('copy');
      copyText.remove();
      this.props.showSuccessNotification(
        `Powered Id "${this.state.image.poweredId}" copied to the clipboard.`
      );
    };
  }

  renderHeader() {
    const nameDisplay =
      this.state.image.name && this.state.image.name !== ' ' ? (
        <span>{truncateString(this.state.image.name, this.props.maxTitleLength)}</span>
      ) : (
        <span>
          <i>No image name</i>
        </span>
      );

    return (
      <div className="header-display">
        <div className="header-label">{nameDisplay}</div>

        <div
          className="icons"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {!this.state.powered ? (
            <i
              onClick={this.onPowerImageClick()}
              class="fa fa-bolt power-item"
              style={{ color: this.state.poweredIconColor, cursor: 'pointer' }}></i>
          ) : (
            <span>
              <i
                onClick={this.onSwapImageClick()}
                class="fa fa-exchange power-item"
                style={{ color: this.state.poweredIconColor, cursor: 'pointer' }}></i>
              <i
                data-tip={this.state.image.poweredId}
                data-for="background"
                data-html
                onClick={this.onUnpowerImageClick()}
                class="fa fa-bolt power-item"
                style={{ color: this.state.poweredIconColor, cursor: 'pointer' }}></i>
              <ReactTooltip id="background" />
            </span>
          )}
        </div>
      </div>
    );
  }

  render() {
    const imgClass = 'album-image img-responsive';

    const thumbImgURL = `${CLOUDINARY_SHARE}/${this.state.image.cloudinaryId}`;
    if (this.state.image.poweredId) {
      this.state.poweredIconColor = '#20BED6';
      this.state.powered = true;
    } else {
      this.state.poweredIconColor = '#000';
      this.state.powered = false;
    }

    return [
      <PowerImageModal
        key="powerImageModal"
        open={this.state.showPowerImageModal}
        itemID={this.state.image.id}
        onConfirm={this.powerImage}
        onClose={this.closeModal}
        onChange={this.updatePoweredID}
        buttonsDisabled={this.state.isPowering}
      />,
      <UnpowerImageModal
        key="unpowerImageModal"
        open={this.state.showUnpowerImageModal}
        itemID={this.state.image.id}
        onConfirm={this.unpowerImage}
        onClose={this.closeModal}
        buttonsDisabled={this.state.isUnpowering}
      />,

      <div className="album-item">
        <div className="view-album-grid-item">
          <div className="grid-item-header">
            <div className="image_header">{this.renderHeader()}</div>
          </div>

          {!this.state.powered ? (
            <div className="thumb-wrapper">
              <div>
                <SquareGridThumb imgSrc={thumbImgURL} className={imgClass} />
              </div>
            </div>
          ) : (
            <div className="thumb-wrapper">
              <div onClick={this.copyPoweredID()} style={{ cursor: 'pointer' }}>
                <SquareGridThumb imgSrc={thumbImgURL} className={imgClass} />
              </div>
            </div>
          )}
        </div>
      </div>,
    ];
  }
}

export default authProtection(withAlertTimeout(SingleImageView));



// WEBPACK FOOTER //
// ./src/views/Components/SingleImageView.js